import UserElement from "../User/UserElement";

export default function Sidebar({
  users,
  schedules,
  onSelect,
  selectedUserID,
}) {
  const getScheduleSummary = (userID) => {
    // Filter schedules for the given userID
    const userSchedules = schedules.filter(
      (s) => s.userID?._id === userID || s.userID?.id === userID
    );

    let totalMilliseconds = 0;

    userSchedules.forEach((shift) => {
      const start = new Date(shift.startTime);
      const end = new Date(shift.endTime);

      let shiftDuration = end - start; // total shift duration in ms

      // Calculate break duration if break times exist
      if (shift.breakStartTime && shift.breakEndTime) {
        const breakStart = new Date(shift.breakStartTime);
        const breakEnd = new Date(shift.breakEndTime);
        const breakDuration = breakEnd - breakStart;

        if (breakDuration > 0 && breakDuration < shiftDuration) {
          shiftDuration -= breakDuration;
        }
      }

      if (shiftDuration > 0) {
        totalMilliseconds += shiftDuration;
      }
    });

    const totalHours = totalMilliseconds / (1000 * 60 * 60);
    const roundedHours = Math.round(totalHours);

    const shiftCount = userSchedules.length;

    return `${roundedHours}hrs / ${shiftCount} shift${
      shiftCount !== 1 ? "s" : ""
    }`;
  };

  const checkApproved = (userID) => {
    let userSchedules = schedules.filter((sc) => sc.userID.id == userID).length;

    if (userSchedules == 0) return false;

    let unApproved = schedules
      .filter((sc) => sc.userID.id == userID)
      .filter((sc) => !sc.approved).length;
    return unApproved == 0;
  };

  return (
    <div className="w-64 border-r overflow-y-auto h-[calc(100vh-200px)]">
      {users.map((user, idx) => (
        <div className="border-b border-gray-100">
          <UserElement
            sheetNumber={getScheduleSummary(user._id)}
            user={user}
            approved={checkApproved(user._id)}
            usage="timesheet"
            onSelect={onSelect}
            selectedUserID={selectedUserID}
          />
        </div>
      ))}
    </div>
  );
}
